import { basicValidation } from '../basicValidation';

export const fileFolderValidation = {
    fileFolder : {
        id: (value:string) =>  basicValidation.resourceId.isValid(value),
        name: (value:string) =>  basicValidation.isValidFileFolderName(value),
        parentFolderId: (value:string | null) => value === null || basicValidation.resourceId.isValid(value)
    }
};